import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../services/config.service';
import { RequestService } from '../../services/request.service';

@Injectable()
export class GdprModalMessageService {

  constructor(
    private configService: ConfigService,
    private requestService: RequestService
  ) { }

  updateEmployeeDetails(details): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.updatePrivatePolicy.api;
    return this.requestService.post(url, details);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/gdpr-modal-message/gdpr-modal-message.service.ts